import React from "react";
import { goToTop } from "helpers/helpers";

export default function Step10({ redirectFinalStep }) {
   const backToHomePage = () => {
      localStorage.removeItem("sessionStepsState");
      localStorage.removeItem("sessionCurrentStep");
      window.location.replace("/");
      goToTop();
   };
   if(redirectFinalStep === "NU_BENEFICIEZI_GAZE") {
      window.dataLayer.push({ event: "pas_final_casnici", info: { pagina: "thank-you", finalizat: "da", eroare: "da", mesaj: "NU_BENEFICIEZI_GAZE" } });
   } else if(redirectFinalStep === "NU_SUNT_DE_ACCORD_GDPR") {
      window.dataLayer.push({ event: "pas_final_casnici", info: { pagina: "thank-you", finalizat: "da", eroare: "da", mesaj: "NU_SUNT_DE_ACCORD_GDPR" } });
   } else {
      window.dataLayer.push({ event: "pas_final_casnici", info: { pagina: "thank-you", finalizat: "da", eroare: "nu", mesaj: "Procesul de contractare s-a finalizat cu succes!" } })
   }
   console.log("start parametrii dataLayer");
   console.log(window.dataLayer);
   console.log("stop parametrii dataLayer");
   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-10">
                     {redirectFinalStep === "NU_BENEFICIEZI_GAZE" ? (
                        <div>
                           <h2 className="mt-80 final_title">
                              Având în vedere că în prezent nu beneficiezi de gaze naturale la locul tău de consum,
                           </h2>
                           <p className="text-center mt-30">
                              Colegii noștri te vor contacta pe adresa ta de e-mail în cel mai scurt timp. Dacă ai nevoie de informații sau detalii
                              suplimentare, ne poți contacta la numărul de telefon la 021 231 10 21 sau prin intermediul{" "}
                              <a href="/contact" className="color-green cursor-pointer" target="_blank">
                                 formularul nostru de contact!
                              </a>
                           </p>
                        </div>
                     ) : redirectFinalStep === "NU_SUNT_DE_ACCORD_GDPR" ? (
                        <div>
                           <h2 className="mt-80 final_title">Ne pare rău că nu îți dorești să continui procesul de contractare.</h2>
                           <p className="text-center mt-30">
                              Îți reamintim că pentru a încheia un contract de furnizare gaze naturale, e nevoie de acordul tău pentru prelucrarea
                              datelor personale. Te așteptăm oricând alături de noi, iar dacă vrei să te informezi cu privire la politica noastră de
                              confidențialitate, găsești{" "}
                              <a href="/gdpr" className="color-green cursor-pointer" target="_blank">
                                 aici
                              </a>{" "}
                              toate detaliile. Poți relua procesul de contractare{" "}
                              <a href="/contractare-online" className="color-green cursor-pointer" target="_blank">
                                 aici
                              </a>
                              , în orice moment dorești.
                           </p>
                        </div>
                     ) : (
                        <div>
                           <h2 className="mt-80 final_title">Îți mulțumim pentru alegerea de a fi clientul nostru!</h2>
                           <p className="text-center mt-30">
                              Îți mulțumim pentru alegerea de a fi clientul nostru! Documentele pe care ni le-ai trimis sunt în curs de verificare și
                              urmează ca în cel mai scurt timp să revenim pe adresa ta de e-mail cu documentele finale. Dacă ai nevoie de informații
                              sau detalii suplimentare, ne poți contacta la numărul de telefon 021. 231.10.21 sau prin intermediul{" "}
                              <a href="/contact" className="color-green cursor-pointer" target="_blank">
                                 formularul nostru de contact.
                              </a>
                           </p>
                        </div>
                     )}
                     <div className="text-center mt-80">
                        <a onClick={() => backToHomePage()} className="link-one t-decoration cursor-pointer">
                           Înapoi pe prima pagină
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
